import React from "react";

function FullViewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        d="M7.286 0C7.982 0 8.57.59 8.57 1.286c0 .75-.589 1.285-1.285 1.285H2.57v4.715c0 .75-.589 1.285-1.285 1.285C.536 8.571 0 8.036 0 7.286v-6A1.27 1.27 0 011.286 0h6zm15.428 0C23.411 0 24 .59 24 1.286v6c0 .75-.59 1.285-1.286 1.285-.75 0-1.285-.535-1.285-1.285V2.57h-4.715c-.75 0-1.285-.535-1.285-1.285A1.27 1.27 0 0116.714 0h6zM7.286 21.429c.696 0 1.285.589 1.285 1.285 0 .75-.589 1.286-1.285 1.286h-6C.536 24 0 23.464 0 22.714v-6a1.27 1.27 0 011.286-1.285c.696 0 1.285.589 1.285 1.285v4.715h4.715zm15.428-6c.697 0 1.286.589 1.286 1.285v6c0 .75-.59 1.286-1.286 1.286h-6c-.75 0-1.285-.536-1.285-1.286a1.27 1.27 0 011.285-1.285h4.715v-4.715a1.27 1.27 0 011.285-1.285z"
      ></path>
    </svg>
  );
}

export default React.memo(FullViewIcon);
